var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-page',{attrs:{"image_source":_vm.image_source,"image_height":_vm.image_height}},[_c('div',{staticClass:"row"},[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_vm._v(" survey ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }